<script>
import BasePopup from '@/components/BasePopup.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseTable from '@/components/base/BaseTableHeaderItem.vue';
import BaseRadio from '@/components/BaseRadio.vue';
import FormBlock from '@/components/FormBlock.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';

export default {
  name: 'SupplierManualDirList',
  components: {
    EllipsisMenu,
    FormBlock,
    BaseRadio,
    BaseTable,
    BaseInput,
    BasePopup,
  },
  controller: null,
  props: {
    items: Array,
  },
  data() {
    return {
      isOpened: false,
      search: '',
      selected: null,
    };
  },
  computed: {
    itemsFiltered() {
      const search = this.search.toLowerCase().replace(/ /g, '');
      return this.items.filter(item => !search || item.name.toLowerCase().replace(/ /g, '').includes(search));
    },
  },
  methods: {
    menuItems(id) {
      return [
        { text: 'Редактировать', icon: 'edit', handler: () => { this.$emit('edit', id); } },
        { text: 'Удалить', icon: 'trash', handler: () => { this.$emit('delete', id); } },
      ];
    },
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    select() {
      this.isOpened = false;
      this.$options.controller.resolve(this.selected);
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve();
    },
  },
};
</script>

<template lang="pug">
BasePopup(v-if="isOpened" @close="close")
  .supplier-manual-dir-list
    .top
      .title Поставщики
      BaseInput(v-model="search" label="Поиск")
    FormBlock
      .items
        .item(v-for="item in itemsFiltered" :key="item.id")
          BaseRadio(:checked="selected === item['@id']" @check="selected = item['@id']")
          .name {{ item.name }}
          EllipsisMenu(:items="menuItems(item.id)")
      .buttons
        Btn(dark @click="$emit('add')")
          Icon(name="plus" pointer)
          | Добавить
        Btn(grey @click="close") Отмена
        Btn(green @click="select" :disabled="!selected") Выбрать

</template>

<style scoped lang="scss">
::v-deep .wrap {
  background: #F8F9FC;
}

.supplier-manual-dir-list {
  padding: 40px;
}

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.title {
  font-size: 36px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
}

.items {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.item {
  display: flex;
  gap: 20px;
  background: #F8F9FC;
  padding: 10px 15px;
}

.name {
  margin-right: auto;
}

.buttons {
  display: flex;
  gap: 20px;
  margin-top: 30px;

  :first-child {
    margin-right: auto;
  }
}
</style>
